const ENVIRONMENT = "production";

Sentry.init({
  environment: `${ENVIRONMENT}`,
  normalizeDepth: 10,
});

const PAYPAL_CONFIG = {
  "development": {
    "DOMAIN": 'https://puebco.us/',
    "SHOPIFY_DOMAIN": 'https://puebco.myshopify.com',
    "SERVER_URL": 'https://fd77-149-248-174-90.ngrok-free.app/paypal',
    "GRAPHQL_URL": 'https://puebco.myshopify.com/api/2025-04/graphql.json',
    "STOREFRONT_ACCESS_TOKEN": "46df831bbbf1c923d503ea8cc5939898",
    // "AFFIRM_PUBLIC_KEY": "LDN8JZMDHO1GV83R"
    "AFFIRM_PUBLIC_KEY": "451P5D54BTLUD5WO",
  },
  "production": {
    "DOMAIN": 'https://puebco.us/',
    "SHOPIFY_DOMAIN": 'https://puebco.myshopify.com',
    "SERVER_URL": 'https://bd-admin-webhooks.burkedecor.site/paypal',
    "GRAPHQL_URL": "https://puebco.myshopify.com/api/2025-04/graphql.json",
    "STOREFRONT_ACCESS_TOKEN": "46df831bbbf1c923d503ea8cc5939898",
    "AFFIRM_PUBLIC_KEY": "451P5D54BTLUD5WO",
  }
}

const DOMAIN = PAYPAL_CONFIG[ENVIRONMENT].DOMAIN;
const SHOPIFY_DOMAIN = PAYPAL_CONFIG[ENVIRONMENT].SHOPIFY_DOMAIN;
const SERVER_URL = PAYPAL_CONFIG[ENVIRONMENT].SERVER_URL;
const STOREFRONT_ACCESS_TOKEN = PAYPAL_CONFIG[ENVIRONMENT].STOREFRONT_ACCESS_TOKEN;
const GRAPHQL_URL = PAYPAL_CONFIG[ENVIRONMENT].GRAPHQL_URL;
const AFFIRM_PUBLIC_KEY= PAYPAL_CONFIG[ENVIRONMENT].AFFIRM_PUBLIC_KEY;
const ATLAS_URL = 'https://atlas.shopifysvc.com/graphql';


const GRAPHQL_BODY = (query, variables=null) => {
  return {
      'async': true,
      'crossDomain': true,
      'method': 'POST',
      'dataType': 'json',
      'headers': {
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
          'Content-Type': 'application/json',
          'Origin': SHOPIFY_DOMAIN,
          'Referer': SHOPIFY_DOMAIN
      },
      'body': JSON.stringify({"query":query, "variables":variables})
  };
}

let timeoutId = null;

function debounce(func, wait) {
  return function(event) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(event), wait);
  }
}

// Model
const model = {
    "cart_items": JSON.parse(document.getElementById("cart_items").textContent),
    "subtotal": document.querySelector(".cart__items").getAttribute("data-cart-subtotal"),
    "delivery": {
      "addressId": "",
      "country": "US",
      "email": "",
      "first_name": "",
      "last_name": "",
      "address1": "",
      "address2": "",
      "city": "",
      "province": "",
      "zip": "",
      "phone": ""
    },
    "billing": {
      "same_as_delivery": true,
      "country": "US",
      "first_name": "",
      "last_name": "",
      "address1": "",
      "address2": "",
      "city": "",
      "province": "",
      "zip": ""
    },
    "shippingRate" : "",
    "discountAmount": 0,
    "discountCode": "",
    "totalAmount": 0,
    "checkoutId": "",
    "paymentMethod": "credit-card",
    "requiresShipping": true,
    "isCustomItems": false,
    "attributes": "",
    "store": "puebco",
}

// Controller 
const controller = {
  init() {
    console.log("starting controller");
    orderPaymentView.init();
    deliveryView.init();
    billingView.init();
    shippingView.init();
    totalCostView.init();
    discountCodeView.init();
    cartItemsView.init();
    this.createCheckout();
    this.calulateTotalAmount();
  },

  async validateForm() {
    // check if all the fields are filled exept address2
    let fields = model.delivery;
    let valid = true;
    let email = fields.email;
    if (!this.validateEmail(email)) {
      deliveryView.fields.email.classList.add("is-invalid");
      return false;
    }
    for (let key in fields) {
      if (key == "addressId") continue;
      if (key == "address2") continue;
      if(key == "fist_name") continue;

      if (fields[key] == "") {
        // if is empty append an error message to the input
        let input = deliveryView.fields[key];
        input.classList.add("is-invalid");
        console.log("invalid", key);
        valid = false;
        break;
      }
    }

    // if not valid then return
    if (!valid) return valid;
    let addressValidation = await this.validateAddress();
    console.log("addressValidation", addressValidation);

    return valid;
  },

  validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  },

  validateAddress() {
    return new Promise((resolve, reject) => {
      console.log("validateAddress");
      let data = {
        "delivery": model.delivery,
      }
      fetch(`${SERVER_URL}/validate_address/`, {
        method: "POST", 
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        let result = data.result;
        let verdict = result?.verdict;
        if (verdict?.hasUnconfirmedComponents) {
          console.log("the address has unconfirmed components");
          let addressResponse = result.address;
          let unconfirmedComponentTypes = addressResponse.unconfirmedComponentTypes;
          for( const component of unconfirmedComponentTypes) {
            switch (component) { 
              case "administrative_area_level_1":
                deliveryView.fields.province.classList.add("is-invalid");
                resultMessage("Please enter a valid state");
                resolve(false);
                break;
  
              case "postal_code":
                deliveryView.fields.zip.classList.add("is-invalid");
                resultMessage("Please enter a valid zip code");
                resolve(false);
                break;
              
              case "locality":
                deliveryView.fields.city.classList.add("is-invalid");
                resultMessage("Please enter a valid city");
                resolve(false);
                break; 
            }
          }
        }
  
        if(verdict?.hasReplacedComponents) {
          console.log("the address has replaced components");
          let addressComponents = result.address.addressComponents;
          for (const component of addressComponents) { 
            if (component.componentType =="postal_code") { 
                deliveryView.fields.zip.classList.add("is-invalid");
                resultMessage("Please enter a valid zip code");
                break;
            }
          }
  
          reject(false);
        }
  
        console.log("the address is valid");
        resolve(true);
      })
      .catch(error => {
        console.error('Error:', error);
        reject(error);
      });
    });
  },

  async fetchAddressSuggestions(address, section) {
    console.log("fetchAddressSuggestions", address);
    // get the address and country code
    // let address = model.delivery.address1;
    let countryCode = section === "delivery" ? model.delivery.country : model.billing.country;

    // // if address is empty then return
    // if (!address) return;

    // if country code is empty then return
    if (!countryCode) return;

    // if address is less than 3 characters then return
    if (address.length < 3) return;

    // if country code is not US then return

    let response = await fetch(`${SERVER_URL}/get_address_suggestions/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        address: address,
        countryCode: countryCode
      })
    });

    let data = await response.json();
    console.log("data", data);
    let predictions = data.predictions;
    if (predictions.length == 0) return;
    if (section == "delivery") deliveryView.renderAutocompleteSuggestions(predictions);
    if (section == "billing") billingView.renderAutocompleteSuggestions(predictions);
    

  },

  async fetchDetailAddress(placeId, section) { 
    console.log("fetchDetailAddress", placeId);
    let response = await fetch(`${SERVER_URL}/get_detail_address/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        placeId: placeId
      })
    });

    let data = await response.json();
    console.log("data", data);

    let suggestion = data.result;
    if (section == "delivery")
    deliveryView.fillSuggestionInputs(suggestion);
    if (section == "billing")
    billingView.fillSuggestionInputs(suggestion);
  
  },

  async calulateTotalAmount() { 
    console.log("calulateTotalAmount");
    let totalAmount = parseFloat(model.subtotal);
    if (model.shippingRate) { 
      totalAmount += parseFloat(model.shippingRate.price);
    }
    if (model.discountAmount) { 
      totalAmount -= parseFloat(model.discountAmount);
    }
    model.totalAmount = totalAmount;
    console.log("totalAmount", totalAmount);

    if (model.shippingRate?.handle && model.totalAmount == 0){
      console.log("your order is free. no paymment is required");
      let checkout = await this.getCheckoutShopify();
      console.log("checkout", checkout);
      if (parseFloat(checkout.paymentDue.amount) == 0) {
        console.log("renderFreePayment");
        totalCostView.renderFreePayment();
      } 
    } else {
      console.log("renderPaypalPayment");
      totalCostView.hideFreePayment();
    }
  },

  async getCartShopify() {
    console.log("getCartShopify");
    let variables = {
      "cartId": model.checkoutId
    }
    
    try {
      // Make the fetch request
      const response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.queryCart(), variables));
      
      // Check if the response is multipart
      const contentType = response.headers.get("content-type") || "";
      
      if (contentType.includes("multipart/mixed")) {
        // Handle multipart/mixed response (incremental delivery)
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        let completeData = {};
        
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          
          // Append the chunk to our buffer
          buffer += decoder.decode(value, { stream: true });
          
          // Process complete parts in the buffer
          const parts = this.extractMultipartParts(buffer);
          buffer = parts.remainingBuffer;
          
          // Process each complete part
          for (const part of parts.completeParts) {
            if (part.trim()) {
              try {
                const json = JSON.parse(part);
                if (json.data) {
                  // Initial response
                  completeData = {...json};
                } else if (json.incremental) {
                  // Incremental update - merge with the complete data
                  json.incremental.forEach(increment => {
                    this.mergeIncrementalData(completeData, increment.path, increment.data);
                  });
                }
              } catch (e) {
                console.error("Error parsing JSON part:", e, part);
              }
            }
          }
        }
        
        return completeData;
      } else {
        // Regular JSON response
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  },
  
  // Helper method to extract complete parts from a multipart response buffer
  extractMultipartParts(buffer) {
    const boundary = buffer.match(/--graphql[^\r\n]*/);
    if (!boundary) return { completeParts: [], remainingBuffer: buffer };
    
    const boundaryString = boundary[0];
    const parts = buffer.split(boundaryString);
    
    // The last part might be incomplete, so we keep it in the buffer
    const completeParts = parts.slice(0, -1);
    const lastPart = parts[parts.length - 1];
    
    // Check if the last part has an ending boundary
    const hasEndingBoundary = lastPart.includes(`--graphql--`);
    
    const processedParts = [];
    // For each complete part, extract just the JSON portion
    for (const part of completeParts) {
      // Find the double newline that separates headers from JSON content
      const jsonStart = part.indexOf('\r\n\r\n');
      if (jsonStart !== -1) {
        // Extract only the JSON content (after headers)
        const jsonContent = part.substring(jsonStart + 4).trim();
        if (jsonContent) {
          processedParts.push(jsonContent);
        }
      }
    }
    
    if (hasEndingBoundary) {
      // Process the last part too if it's complete
      const jsonStart = lastPart.indexOf('\r\n\r\n');
      if (jsonStart !== -1) {
        const jsonContent = lastPart.substring(jsonStart + 4).trim();
        if (jsonContent && !jsonContent.includes('--graphql--')) {
          processedParts.push(jsonContent);
        }
      }
      return { completeParts: processedParts, remainingBuffer: "" };
    } else {
      // Keep the last part in the buffer
      return { completeParts: processedParts, remainingBuffer: boundaryString + lastPart };
    }
  },
  
  // Helper method to merge incremental data into the complete data
  mergeIncrementalData(data, path, incrementalData) {
    if (!data.data) {
      data.data = {};
    }
    
    let current = data.data;
    // Navigate to the correct location in the object
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];
      if (!current[key]) {
        current[key] = {};
      }
      current = current[key];
    }
    
    // Set the value at the final path
    const lastKey = path[path.length - 1];
    current[lastKey] = {...current[lastKey], ...incrementalData};
  },

  async getCheckoutShopify() {
    console.log("getCheckout");
    let variables = {
      "checkoutId": model.checkoutId
    }
  
    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.queryCheckout(), variables));
    let data = await response.json();
    console.log("getCheckoutResponse", JSON.stringify(data));
    let checkout = data.data.node;
  
    while (!checkout.ready) {
      await new Promise(resolve => setTimeout(resolve, 500));
      response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.queryCheckout(), variables));
      data = await response.json();
      console.log("getCheckoutResponse", JSON.stringify(data));
      checkout = data.data.node;
    }
  
    return checkout;
  },
    

  async completeFreeCheckoutHandler() {
    console.log("completeFreeCheckoutHandler");
    let checkout = await this.getCheckoutShopify();
    console.log("checkout", checkout);
    if (parseFloat(checkout.paymentDue.amount) != 0) {
      console.log("payment is required");
      resultMessage("Sorry, your order could not be processed.");
      return;
    }

    let completeCheckout = await this.completeFreeCheckoutShopify();
    console.log("completeCheckout", completeCheckout);

    if (completeCheckout.checkoutUserErrors.length > 0) {
      console.log("there is an error here");
      captureMessage('Checkout Complete Free Error', { extra: { "error": JSON.stringify(completeCheckout.checkoutUserErrors) } });
      resultMessage("Sorry, your order could not be processed.");
      return;
    }

    let completedOrder = await this.getCheckoutShopify();
    console.log("completedOrder", completedOrder);

    let completedOrderStatusUrl = completedOrder.orderStatusUrl;
    window.location.href = completedOrderStatusUrl;
  },

  async completeFreeCheckoutShopify() { 
    console.log("checkoutCompleteFreeHandler");
    let variables = {
      "checkoutId": model.checkoutId
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCheckoutCompleteFree(), variables));
    let data = await response.json();
    console.log("checkoutCompleteFreeResponse", JSON.stringify(data));
    let checkout = data.data.checkoutCompleteFree;
    return checkout;

  },

  deliveryChangeHandler(event=null) { 
    console.log("deliveryChangeHandler");
    let country_code = model.delivery.country;
    deliveryView.removeInvalidClassFields(); 
    if( country_code && country_states[country_code] && !model.delivery.province) {
      console.log("reseting", model.delivery.province);
      model.shippingRate = "";
      shippingView.hideShippingOptions();
      this.calulateTotalAmount();
      totalCostView.updateView();
      return;
    }

    if (model.shippingRate == "") {
      shippingView.hideShippingOptions();
      this.calulateTotalAmount();
      totalCostView.updateView();
    }

    if (model.delivery.country && model.delivery.address1 && model.delivery.city  && model.delivery.zip && model.delivery.last_name ) {
      this.getShippingOptions2();
    }
  },

  getShippingOptions() {
    return new Promise((resolve, reject) => {
      console.log("getShippingOptions");
      let data = {
        "delivery": model.delivery,
        "cart_items": model.cart_items,
        "store": model.store,
      }
  
      fetch(`${SERVER_URL}/get_shipping_options/`, {
        method: "POST", 
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        console.log("getShippingOptions Draft Order");
        resolve(data.available_rates);
      })
      .catch(error => {
        console.error('Error:', error);
        reject(error);
      });
    });
  },

  async deleteDraftOrder() { 
    console.log("deleteDraftOrder");
    let response = await fetch(`${SERVER_URL}/delete_draft_order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        draft_order_id: model.draftOrderId,
        store: model.store,
      }),
    });
    let data = await response.json();
    console.log("data", data);
  },

  async getShippingOptionsStorefront() { 
    console.log("getShippingOptionsStorefront");
    let variables = {
      "checkoutId": model.checkoutId,
      "shippingAddress": {
        "address1": model.delivery.address1,
        "address2": model.delivery.address2,
        "city": model.delivery.city,
        "country": model.delivery.country,
        "firstName": model.delivery.first_name,
        "lastName": model.delivery.last_name,
        "phone": model.delivery.phone,
        "province": model.delivery.province,
        "zip": model.delivery.zip
      }
    }

    console.log("variables", JSON.stringify(variables));
    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationShippingAddressUpdate(), variables));
    let data = await response.json();
    console.log("getShippingOptionsStorefront", JSON.stringify(data));

    let checkoutShippingAddressUpdateV2 = data.data.checkoutShippingAddressUpdateV2;

    if (!checkoutShippingAddressUpdateV2.checkout.ready) {
      console.log("checkout is not ready");
      while (!checkoutShippingAddressUpdateV2.checkout.ready) {
        await new Promise(resolve => setTimeout(resolve, 500));
        response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.queryCheckout(), variables));
        data = await response.json();
        console.log("getShippingOptionsStorefront Inside", JSON.stringify(data));
        checkoutShippingAddressUpdateV2.checkout = data.data.node;
      }
    }

    return checkoutShippingAddressUpdateV2;
    
  },

  async updateCartDeliveryAddress() { 
    console.log("updateCartDeliveryAddress");
    let variables = {
      "cartId": model.checkoutId,
      "addresses": [
        {
          "selected": true,
          "id": model.delivery.addressId,
          "address": {
            "deliveryAddress": {
              "address1": model.delivery.address1,
              "address2": model.delivery.address2,
              "city": model.delivery.city,
              "countryCode": model.delivery.country,
              "firstName": model.delivery.first_name,
              "lastName": model.delivery.last_name,
              "phone": model.delivery.phone,
              "provinceCode": model.delivery.province,
              "zip": model.delivery.zip
            }
          }
        }
      ],
      "validationStrategy" : "STRICT"
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartDeliveryAddressUpdate(), variables));
    let data = await response.json();
    console.log("updateCartDeliveryAddress", JSON.stringify(data));
    let addressId = data.data.cartDeliveryAddressesUpdate.cart.delivery.addresses[0].id;
    console.log("addressId", addressId);
    model.delivery.addressId = addressId;
  },

  async addCartDeliveryAddress() { 
    console.log("addCartDeliveryAddress");
    let variables = {
      "cartId": model.checkoutId,
      "addresses": [
        {
          "selected": true,
          "address": {
            "deliveryAddress": {
              "address1": model.delivery.address1,
              "address2": model.delivery.address2,
              "city": model.delivery.city,
              "countryCode": model.delivery.country,
              "firstName": model.delivery.first_name,
              "lastName": model.delivery.last_name,
              "phone": model.delivery.phone,
              "provinceCode": model.delivery.province,
              "zip": model.delivery.zip
            }
          }
        }
      ],
      "validationStrategy" : "STRICT"
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartDeliveryAddressAdd(), variables));
    let data = await response.json();
    console.log("addCartDeliveryAddress", JSON.stringify(data));

    let addressId = data.data.cartDeliveryAddressesAdd.cart.delivery.addresses[0].id;
    console.log("addressId", addressId);
    model.delivery.addressId = addressId;

  },

  async selectCardDeliveryOption() {
    console.log("selectCardDeliveryOption");
    let variables = {
      "cartId": model.checkoutId,
      "shippingRateHandle": model.shippingRate.handle
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartSelectDeliveryOption(), variables));
    let data = await response.json();
    console.log("selectCardDeliveryOption", JSON.stringify(data));
  },

  async getShippingOptions2() {
    console.log("getShippingOptions2");
    let isValidAddress = await  this.validateForm();
    if (!isValidAddress) {
      console.log("address is not valid");
      return;
    }

    if (model.delivery.addressId != "")  {
      await this.updateCartDeliveryAddress();
    } else {
      await this.addCartDeliveryAddress();
    }
    // let checkoutShippingAddressUpdateV2 = await this.getShippingOptionsStorefront();
    // console.log("getShippingOptions2", JSON.stringify(checkoutShippingAddressUpdateV2));

    // // if error show error message
    // if (checkoutShippingAddressUpdateV2.checkoutUserErrors.length > 0) {
    //   console.log("there is an error here");
    //   let error = checkoutShippingAddressUpdateV2.checkoutUserErrors[0];
    //   let code = error.code;
    //   let field = error.field;
    //   let message = error.message;

    //   if (code == "INVALID_FOR_COUNTRY_AND_PROVINCE") { 
    //     // if "zip" in field - field is an array then show error message in zip input
    //     if (field.includes("zip")) {
    //       deliveryView.fields.zip.classList.add("is-invalid");
    //       resultMessage(message);
    //       return;
    //     }
    //   }
    // }

    // let checkout = await this.getCheckoutShopify();
    // console.log("checkout", checkout);
    // let availableRates = checkout.availableShippingRates?.shippingRates;

    // console.log("rates", availableRates);
    // if (availableRates && availableRates.length == 0) {
    //   model.shippingRate = ""; 
    //   shippingView.hideShippingOptions();
    //   this.calulateTotalAmount();
    //   totalCostView.updateView();
    //   return;
    // }

    let cart = await this.getCartShopify();
    console.log("cart", JSON.stringify(cart));
    const deliveryGroupId = cart?.data?.cart?.deliveryGroups?.edges?.[0]?.node?.id || null;
    
    if (!deliveryGroupId) {
      console.error("No delivery group ID found in cart response");
      return;
    }
    
    // Store delivery group ID for later use in shipping rate selection
    model.deliveryGroupId = deliveryGroupId;
    let draftAvailableRates;
    try {
      draftAvailableRates = await this.getShippingOptions();
      console.log("draftAvailableRates", draftAvailableRates);
    } catch (error) {
      model.shippingRate = ""; 
      shippingView.hideShippingOptions();
      this.calulateTotalAmount();
      totalCostView.updateView();
      return;
    }

    let deliveryOptions = cart?.data?.cart?.deliveryGroups?.edges?.[0]?.node?.deliveryOptions;

    // availableRates.map((rate) => {
    //   let draftOrderRate = draftAvailableRates.filter((draftRate) => {
    //     return draftRate.title == rate.title;
    //   });

    //   if (draftOrderRate.length > 0) {
    //     rate.draftOrderHandle = draftOrderRate[0].handle;
    //   }
    // });

    // console.log("availableRates merged", availableRates);

    deliveryOptions.map((option) => {
      let draftOrderRate = draftAvailableRates.filter((draftRate) => {
        return draftRate.title == option.title;
      });
      if (draftOrderRate.length > 0) {
        option.draftOrderHandle = draftOrderRate[0].handle;
      }
    });

    console.log("deliveryOptions merged", deliveryOptions);

    shippingView.shippingOptionsError.classList.add("hide");
    shippingView.shippingOptions.classList.remove("hide");
    shippingView.updateShippingOptions(deliveryOptions);
  
  },

  async shippingChangeHandler() { 
    console.log("shippingChangeHandler");
    await this.updateCartShippingOption();
    this.calulateTotalAmount();
    totalCostView.updateView();
  },

  async updateCartShippingOption() {
    console.log("updateCartShippingOption");
    let variables = {
      "cartId": model.checkoutId,
      "selectedDeliveryOptions": [
        {
          "deliveryGroupId": model.deliveryGroupId,
          "deliveryOptionHandle": model.shippingRate.handle
        }
      ]
    }
    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartSelectDeliveryOption(), variables));
    let data = await response.json();
    console.log("updateCartShippingOption", JSON.stringify(data));
  },

  async updateCheckoutShippingLine() { 
    console.log("updateCheckoutShippingLine");
    let variables = {
      "checkoutId": model.checkoutId,
      "shippingRateHandle": model.shippingRate.handle
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationShippingLineUpdate(), variables));
    let data = await response.json();
    console.log("updateCheckoutShippingLine", JSON.stringify(data));
    // check for errors
    if (data.data.checkoutShippingLineUpdate.checkoutUserErrors.length > 0) {
      console.log("there is an error here");
      let error = data.data.checkoutShippingLineUpdate.checkoutUserErrors[0];
      let code = error.code;
      let field = error.field;
      let message = error.message;

      if (code == "INVALID" && field[0] == "shippingRateHandle") { 
        // we need to recalculated shipping rates
        model.shippingRate = "";
        controller.deliveryChangeHandler();
      }
    }
    
  },

  async updateCheckoutEmail() { 
    console.log("updateCheckoutEmail");
    let variables = {
      "cartId": model.checkoutId,
      "buyerIdentity": {
        "email": model.delivery.email
      }
    }

    Sentry.addBreadcrumb({category: 'updateCheckoutEmail', message: "update checkout email variables", level: 'info', data: variables});
    try {
      let data = await fetchWithRetry(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartEmailUpdate(), variables));
      Sentry.addBreadcrumb({category: 'updateCheckoutEmail', message: "update checkout email response", level: 'info', data: data});
      console.log("updateCheckoutEmail", JSON.stringify(data));
      model.checkoutId = data.data.cartBuyerIdentityUpdate.cart.id;
      model.webUrl = data.data.cartBuyerIdentityUpdate.cart.checkoutUrl;

      if (data.data.cartBuyerIdentityUpdate.userErrors.length > 0) {
        let error = data.data.cartBuyerIdentityUpdate.userErrors[0];
        let code = error.code;
        let field = error.field;
        let message = error.message;
        if (code == "INVALID" && field.includes("email")) { 
          deliveryView.fields.email.classList.add("is-invalid");
          resultMessage(message);
          return;
        }
      }

      clearResultMessage();
    } catch (error) {
      console.log("error", error);
      Sentry.captureMessage("Update Checkout Email Failed", { extra: { "error": error }, level: "error" });
      resultMessage("Sorry, there is an error. Please try again.");
    }
  },

  async createCheckout() {
    console.log("createCheckout");
    // using shopify Storefront API lets create a checkout
    let lineItems = [];
    model.cart_items.items.map((item) => {
      lineItems.push({
        "merchandiseId": `gid://shopify/ProductVariant/${item.variant_id}`,
        "quantity": parseInt(item.quantity)
      });
    });

    let variables = {
      "input": {
        "lines": lineItems
      }
    }

    Sentry.addBreadcrumb({category: 'createCheckout', message: "create checkout", level: 'info', data: variables});

    try {
      let data = await fetchWithRetry(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCreateCart(), variables));
      Sentry.addBreadcrumb({category: 'createCheckout', message: "create checkout response", level: 'info', data: data});
      console.log("createCheckoutResponse", JSON.stringify(data));
      model.checkoutId = data.data.cartCreate.cart.id;
      model.webUrl = data.data.cartCreate.cart.checkoutUrl;
      Sentry.captureMessage('Redirect to paypal checkout', { extra: { "checkoutId": model.checkoutId } });
      // this.applyTestDiscount();
      // this.testGetDirections();
    } catch (error) {
      console.log("error", error);
      Sentry.captureMessage("Create Checkout Failed", { extra: { "error": error }, level: "error" });
      resultMessage("Sorry, there is an error. Please try again.");
    }
  },

  async createAffirmCheckout() { 
    console.log("createAffirmCheckout");
    let isFormValid = await controller.validateForm();
    if (!isFormValid) {
      resultMessage("Please fill out all fields correctly");
      return;
    }

    totalCostView.AffirmSubmitBtn.classList.add("btn--loading");

    const response = await fetch(`${SERVER_URL}/create_affirm_order/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        delivery: model.delivery,
        billing: model.billing,
        cart_items: model.cart_items,
        shippingRate: model.shippingRate,
        discountAmount: model.discountAmount,
        discountCode: model.discountCode,
      })
    });

    const data = await response.json();

    if (data.status == "error") { 
      resultMessage(
        `Sorry, your transaction could not be processed.<br>`,
      );
      totalCostView.AffirmSubmitBtn.classList.remove("btn--loading");
      return;
    }

    console.log("orderData", JSON.stringify(data));

    const dratfOrder = data.draft_order
    model.draftOrderId = dratfOrder.id;


    let checkout = {
      "merchant": {
        "user_confirmation_url": `${SERVER_URL}/authorize_affirm_checkout/`,
        "user_cancel_url": `${DOMAIN}/pages/paypal-checkout`,
        "public_api_key": AFFIRM_PUBLIC_KEY,
        // "user_confirmation_url_action": "POST",
        "name": "Burke Decor"
      },
      "order_id": model.draftOrderId,
      "shipping": {
        "name": {
          "first": model.delivery.first_name,
          "last": model.delivery.last_name
        },
        "address": {
          "line1": model.delivery.address1,
          "line2": model.delivery.address2,
          "city": model.delivery.city,
          "state": model.delivery.province,
          "zipcode": model.delivery.zip,
          "country": model.delivery.country
        },
        "phone_number": model.delivery.phone,
        "email": model.delivery.email
      },
      "billing": {
        "name": {
          "first": dratfOrder.billing_address.first_name,
          "last": dratfOrder.billing_address.last_name
        },
        "address": {
          "line1": dratfOrder.billing_address.address1,
          "line2": dratfOrder.billing_address.address2,
          "city": dratfOrder.billing_address.city,
          "state": dratfOrder.billing_address.province,
          "zipcode": dratfOrder.billing_address.zip,
          "country": dratfOrder.billing_address.country
        }
      },
      "items": model.cart_items.items.map((item) => {
        return {
          "display_name": item.title,
          "sku": item.sku,
          "unit_price": sanitizeValue(item.price),
          "qty": item.quantity,
          "item_image_url": item.image_url
        }
      }),
      "metadata": {
        "mode": "modal"
      },
      "shipping_amount": sanitizeValue(dratfOrder.shipping_line?.price),
      "tax_amount": sanitizeValue(dratfOrder.total_tax),
      "total": sanitizeValue(dratfOrder.total_price),

    }

    console.log("checkout", checkout);
    affirm.checkout(checkout);

    affirm.checkout.open({
      onFail: function (error) { 
        console.log("onFail", error);
        Sentry.captureMessage(`Affirm checkout failed - ${error.reason}`, { extra: { "error": error } });
        resultMessage(
          `Sorry, your transaction could not be processed.<br>${error.reason}`,
        );
        totalCostView.AffirmSubmitBtn.classList.remove("btn--loading");
        controller.deleteDraftOrder();
      },
      onSuccess: function (checkout) {
        console.log("onSuccess", JSON.stringify(checkout));
        Sentry.captureMessage('Affirm checkout', { extra: { "checkout": JSON.stringify(checkout) } });
        console.log("onSuccess", checkout.checkout_token);
        controller.authorizeAffirmCheckout(checkout.checkout_token);
      },

      onOpen: function(token) {
        console.log("onOpen", token);
      },
      onValidationErrors: function(error) {
        console.log("onValidationErrors", error);
        Sentry.captureMessage('Affirm Validation errors', { extra: { "error": error } });
        resultMessage(
          `Sorry, your transaction could not be processed.<br>`,
        );
        totalCostView.AffirmSubmitBtn.classList.remove("btn--loading");
        controller.deleteDraftOrder();
      }
    });
  },

  async authorizeAffirmCheckout(token) { 
    console.log("authorizeAffirmCheckout");
    if (!token) {
      resultMessage("Sorry, your transaction could not be processed.");
      Sentry.captureMessage('Affirm - No Authorization Token');
      return;
    }
    let response = await fetch(`${SERVER_URL}/authorize_affirm_checkout/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: token,
        draft_order_id: model.draftOrderId,
      })
    });

    let data = await response.json();
    if (data.status == "error") {
      resultMessage("Sorry, your transaction could not be processed.");
      return;
    }
    console.log("authorizeAffirmCheckout", JSON.stringify(data));
    Sentry.captureMessage('Affirm Purchase Complete', { extra: { "checkoutId": model.checkoutId } });
    if (data.url) {
      window.location.href = data.url;
    } else {
      resultMessage("Transaction Complete");
      totalCostView.AffirmSubmitBtn.classList.remove("btn--loading");
    }
  },

  async removeDiscountHandler() { 
    console.log("removeDiscount");
    this.applyDiscount();
    this.removeDiscount();
    discountCodeView.removeDiscountCode();
  },

  async applyDiscount(discountCode="") {   
    console.log("applyDiscount", discountCode);
    model.discountCode = discountCode;
    let variables = {
      "cartId": model.checkoutId,
    }

    if (discountCode) {
      variables.discountCodes = [discountCode];
    } else {
      variables.discountCodes = [];
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationCartDiscountCode(), variables));
    let data = await response.json();
    console.log("applyDiscountResponse", JSON.stringify(data));
  
    const cartDiscountCodesUpdate = data.data.cartDiscountCodesUpdate;
    const cartDiscountCodes = cartDiscountCodesUpdate.cart.discountCodes;
    const appliedCode = cartDiscountCodes.find(code => code.code.toLowerCase() === discountCode.toLowerCase());
    if (appliedCode && !appliedCode.applicable) {
      console.log("Discount code not applicable:", appliedCode);
      this.removeDiscount();
      discountCodeView.showDiscountCodeError("DISCOUNT_NOT_APPLICABLE", discountCode);
      return;
    }

    // let errors = data.errors;
    // console.log("errors", errors);
    // if (errors && errors.length > 0) {
    //   console.log(errors[0].message);
    //   discountCodeView.showDiscountCodeError("DISCOUNT_NOT_FOUND");
    //   return;
    // }

    // let checkout = data.data.checkoutDiscountCodeApplyV2?.checkout;
    // let checkoutUserErrors = data.data.checkoutDiscountCodeApplyV2.checkoutUserErrors;
    // if (checkoutUserErrors && checkoutUserErrors.length > 0) {
    //   // check if any item of checkoutuserErros has code "DISCOUNT_NOT_FOUND"
    //   let discountNotFound = checkoutUserErrors.filter((error) => {
    //     return error.code == "DISCOUNT_NOT_FOUND";
    //   });

    //   // if discountNotFound then show error message
    //   if (discountNotFound.length > 0) {
    //     discountCodeView.showDiscountCodeError("DISCOUNT_NOT_FOUND");
    //     return;
    //   }

    //   let discountExpired = checkoutUserErrors.filter((error) => {
    //     return error.code == "DISCOUNT_EXPIRED";
    //   });

    //   if (discountExpired.length > 0) {
    //     discountCodeView.showDiscountCodeError("DISCOUNT_EXPIRED");
    //     return;
    //   }

    //   this.removeDiscount();

    //   discountCodeView.showDiscountCodeError("ERROR");

    //   return;
    // } 

    // // this is the case when is a shipping free discount code
    // if (checkout && checkout.shippingDiscountAllocations.length > 0) {
    //   let shippingDiscount = checkout.shippingDiscountAllocations[0].allocatedAmount.amount;
    //   model.discountAmount = shippingDiscount*100;
    //   this.calulateTotalAmount();
    //   totalCostView.updateView(discountCode);
    //   discountCodeView.renderDiscountCode(discountCode);
    //   return;
    // }

    // // this is the case when the discount code is not valid for the items in the cart. this case happens when the lineItemsSubtotalPrice and the paymentDue are the same and there is no discount allocations in all the lineItems

    // let discountAllocations = checkout.lineItems.edges.filter((item) => {
    //   return item.node.discountAllocations.length > 0;
    // });


    // if (checkout.lineItemsSubtotalPrice.amount == checkout.paymentDue.amount && discountAllocations.length == 0) { 
    //   this.removeDiscount();
    //   discountCodeView.showDiscountCodeError("DISCOUNT_NOT_APPLICABLE", discountCode);
    //   return;
    // }


    // this is the case when the discount code is applied to the line items

    const lineItems = cartDiscountCodesUpdate.cart.lines.edges;
    lineItems.forEach((item) => {
      const discountAllocations = item.node.discountAllocations;
      let totalAmount = parseFloat(item.node.cost.totalAmount.amount);
      let subtotalAmount = parseFloat(item.node.cost.subtotalAmount.amount);
      let variantId = item.node.merchandise.id;
      variantId = variantId.replace("gid://shopify/ProductVariant/", "");
      let discountedAmount = discountAllocations.length > 0 ? parseFloat(discountAllocations[0].discountedAmount.amount) : 0;
      // now we need to change this values in the model
      let cartItem = model.cart_items.items.filter((item) => {
        return item.variant_id == variantId;
      });
      if (cartItem.length > 0) {
        cartItem[0].discountedAmount = discountedAmount;
        cartItem[0].totalAmount = totalAmount;
        cartItem[0].subtotalAmount = subtotalAmount;
      }
    });

    console.log("cartItem", model.cart_items);
      

    // this is the case when the discount code is valid
    let discountAmount = parseFloat(cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount) - parseFloat(cartDiscountCodesUpdate.cart.cost.totalAmount.amount);
    // let discountAmount = parseFloat(cartDiscountCodesUpdate.cart.discountAllocations[0].discountedAmount.amount);
    // let discountAmount = parseFloat(checkout.lineItemsSubtotalPrice.amount) - parseFloat(checkout.paymentDue.amount);
    model.subtotal = parseFloat(cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount)*100;
    model.discountAmount = discountAmount*100;
    this.calulateTotalAmount();
    totalCostView.updateView(discountCode);
    cartItemsView.updateLineItems();
    discountCodeView.renderDiscountCode(discountCode);
  },

  async removeDiscount() { 
    model.discountAmount = 0;
    this.calulateTotalAmount();
    totalCostView.updateView();
  }, 

  async applyTestDiscount() {   
    console.log("applyTestDiscount");
    let variables = {
      "checkoutId": model.checkoutId,
      "discountCode": "CC6H-"
    }

    let response = await fetch(GRAPHQL_URL, GRAPHQL_BODY(this.mutationApplyDiscount(), variables));
    let data = await response.json();
    console.log("data", data);
  },

  async testGetDirections() { 
    console.log("testGetDirections");
    let variables = {
      "location": {
        "latitue":43.6653,
        "longitude":-79.4343
      },
      "query": "2841 Bryant Avenue South",
      "countryCode": "US",
      "locale": "EN-US",
      "sessionTokeb": model.checkoutId
    }

    let response = await fetch(ATLAS_URL, GRAPHQL_BODY(this.getDirections(), variables));
    let data = await response.json();
    console.log("data", JSON.stringify(data));
  },

  mutationCartGiftCartUpdate() {
    return `mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) { 
      cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
        cart {
          id
          appliedGiftCards {
            amountUsed {
              amount
            }
            id
          }
          userErrors { 
            field
            message
            code
          }
          warnings {
            message
            target
            code
          }
        }
      }
    }`;
  },

  mutationCartDiscountCode() {
    return `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) { 
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) { 
        cart {
          id
          cost {
            subtotalAmount {
              amount
            }
            totalAmount {
              amount
            }
          }
          discountCodes {
            applicable
            code
          }
          discountAllocations {
            discountedAmount {
              amount
            }
          }
          lines(first: 20) {
            edges {
              node {
                discountAllocations {
                  discountedAmount {
                    amount
                  }
                }
                id
                merchandise { 
                  ... on ProductVariant {
                    id
                    title
                  }
                }
                cost {
                  subtotalAmount {
                    amount
                  }
                  totalAmount {
                    amount
                  }
                }
              }
            }
          }
        }
        userErrors { 
          field
          message
          code
        }
        warnings {
          message
          target
          code
        }
      }
    }`;
  },

  mutationApplyDiscount() {
    return `mutation checkoutDiscountCodeApplyV2($checkoutId: ID!, $discountCode: String!) {
      checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode) {
        checkout {
          id 
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          shippingDiscountAllocations {
            allocatedAmount {
              amount
            }

          }
          shippingLine {
            handle
            priceV2 {
              amount
            }
            title
          }
          paymentDue {
            amount
          }
          lineItems(first:10) {
            edges {
              node {
                id
                title
                quantity
                discountAllocations {
                  allocatedAmount {
                    amount
                  }
                  discountApplication {
                    targetSelection
                    targetType
                    value
                  }
                }
              }
            }
          }
          discountApplications(first:10) {
            edges {
              node {
                allocationMethod
                targetSelection
                targetType
                value

              }
            }
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  },

  mutationCreateCheckout() {
    return `mutation checkoutCreate($input: CheckoutCreateInput!) { 
      checkoutCreate(input: $input) { 
        checkout { 
          id 
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          paymentDue {
            amount
          }
          lineItems(first:10) {
            edges {
              node {
                id
                title
                quantity
                discountAllocations {
                  allocatedAmount {
                    amount
                  }
                  discountApplication {
                    targetSelection
                    targetType
                    value
                  }
                }
              }
            }
          }
          discountApplications(first:10) {
            edges {
              node {
                allocationMethod
                targetSelection
                targetType
                value
              }
            }
          } 
        } 
        checkoutUserErrors { 
          code 
          field 
          message 
        } 
      } 
    }`;
  },

  queryCart() {
    return `query cart($cartId: ID!) {
      cart(id: $cartId) {
        cost {
          subtotalAmount {
            amount
          }
          totalAmount {
            amount
          }
        }

        discountCodes {
          applicable
          code
        }

        ... DeliveryGroups @defer
      }
    }

    fragment DeliveryGroups on Cart { 
      deliveryGroups(first: 5, withCarrierRates: true) { 
        edges {
          node {
            id
            deliveryOptions {  
              title
              handle
              estimatedCost {
                amount
              }
            }
            selectedDeliveryOption {
              title
              handle
              estimatedCost {
                amount
              }
            }
          }
        }
      }
    
    }`
  },

  mutationCreateCart() {
    return `mutation cartCreate($input: CartInput) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors { 
          field
          message
        }
      }
    }`
  },

  mutationCartEmailUpdate() {
    return `mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
      cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
          code
        }
        warnings {
          message
          target
          code
        }
      }
    }`
  },

  mutationCartDeliveryAddressUpdate() {
    return `mutation CartDeliveryAddressesUpdate($cartId: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
      cartDeliveryAddressesUpdate(cartId: $cartId, addresses: $addresses) {
        cart {
          id
          delivery {
            addresses {
              id
            }
          }
        }
        userErrors {
          field
          message
          code
        }
        warnings {
          message
          target
          code
        }
      }  
    }`;
  },

  mutationCartDeliveryAddressAdd() {
    return `mutation CartDeliveryAddressesAdd($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {
      cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {
        cart {
          id
          delivery {
            addresses {
              id
            }
          }
        }
        userErrors {
          field
          message
          code
        }
        warnings {
          message
          target
          code
        }
      }  
    }`;
  },

  mutationCartSelectDeliveryOption() { 
    return `mutation cartSelectedDeliveryOptionsUpdate($cartId: ID!, $selectedDeliveryOptions: [CartSelectedDeliveryOptionInput!]!) {
      cartSelectedDeliveryOptionsUpdate(cartId: $cartId, selectedDeliveryOptions: $selectedDeliveryOptions) {
        cart {
          id
        }
        userErrors {
          field
          message
          code
        }
        warnings {
          message
          target
          code
        }
      }
    }`;
  },

  getDirections() {
    return `query prediction($query: String, $countryCode: AutocompleteSupportedCountry!, $locale: String!, $sessionToken: String, $location: LocationInput) {      predictions(query: $query, countryCode: $countryCode, locale: $locale, sessionToken: $sessionToken, location: $location) {
        addressId
        description
        completionService
        matchedSubstrings {
          length
          offset
        }
      }
    }`
  },
  
  mutationRemoveDiscount() { 
    return `mutation checkoutDiscountCodeRemove($checkoutId: ID!) {
      checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
        checkout {
          id 
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          paymentDue {
            amount
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  
  },

  mutationShippingAddressUpdate() {
    return `mutation checkoutShippingAddressUpdateV2($checkoutId: ID!, $shippingAddress: MailingAddressInput!) {
      checkoutShippingAddressUpdateV2(checkoutId: $checkoutId, shippingAddress: $shippingAddress) {
        checkout {
          id 
          webUrl
          ready
          availableShippingRates {
            ready
            shippingRates {
              handle
              priceV2 {
                amount
              }
              title
            }
          }
          lineItemsSubtotalPrice {
            amount
          }
          paymentDue {
            amount
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  
  },

  mutationShippingLineUpdate() {
    return `mutation checkoutShippingLineUpdate($checkoutId: ID!, $shippingRateHandle: String!) {
      checkoutShippingLineUpdate(checkoutId: $checkoutId, shippingRateHandle: $shippingRateHandle) {
        checkout {
          id 
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          paymentDue {
            amount
          }
          shippingLine {
            handle
            priceV2 {
              amount
            }
            title
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  },

  mutationCheckoutEmailUpdate() { 
    return `mutation checkoutEmailUpdateV2($checkoutId: ID!, $email: String!) {
      checkoutEmailUpdateV2(checkoutId: $checkoutId, email: $email) {
        checkout {
          id 
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          paymentDue {
            amount
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  },

  queryAvailableCountries() { 
    return `query {
      shop {
        shipsToCountries {
        }
      }
    }`;
  },

  mutationCheckoutCompleteFree() { 
    return `mutation checkoutCompleteFree($checkoutId: ID!) {
      checkoutCompleteFree(checkoutId: $checkoutId) {
        checkout {
          id 
          webUrl
          orderStatusUrl
          order {
            id
            statusUrl
          }
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }`;
  
  },

  queryCheckout() { 
    return `query checkout($checkoutId: ID!) {
      node(id: $checkoutId) {
        ... on Checkout {
          id
          webUrl
          lineItemsSubtotalPrice {
            amount
          }
          availableShippingRates {
            ready
            shippingRates {
              handle
              priceV2 {
                amount
              }
              title
            }
          }
          paymentDue {
            amount
          }
          ready
          orderStatusUrl
          order {
            id
            statusUrl
          }
          shippingLine {
            handle
            priceV2 {
              amount
            }
            title
          }
          discountApplications(first:10) {
            edges {
              node {
                allocationMethod
                targetSelection
                targetType
                value
              }
            }
          }
        }
      }
    }`;
  }
}

// View
const orderPaymentView = { 
  init() { 
    
  }
}

const deliveryView = {
  init() { 
    this.fields = {
      email: document.querySelector("#ContactFormEmail"),
      first_name: document.querySelector("#ContactFormFirstName"),
      last_name: document.querySelector("#ContactFormLastName"),
      address1: document.querySelector("#ContactFormAddress1"),
      address2: document.querySelector("#ContactFormAddress2"),
      city: document.querySelector("#ContactFormCity"),
      province: document.querySelector("#ContactFormState"),
      zip: document.querySelector("#ContactFormZipCode"),
      phone: document.querySelector("#ContactFormPhone")
    };
    this.autocompleteSuggestionsContainer = document.querySelector("#autocomplete-suggestions-container");
    this.autocompleteSuggestions = document.querySelector("#autocomplete-suggestions");
    this.suggestionsCloseBtn = document.querySelector("#suggestions-close-btn");

    model.delivery.country = 'US';

    this.country = document.querySelector("#ContactFormCountry");
    this.country.addEventListener("change", (event) => { 
      let selectionOption = event.target.selectedOptions[0];
      model.delivery.country = selectionOption.getAttribute("data-code");
      model.shippingRate = ""; // reset shipping rate
      console.log("model.delivery.country", model.delivery.country);
      this.changeStateOptions(model.delivery.country);
      controller.deliveryChangeHandler(event);
    });

    this.suggestionsCloseBtn.addEventListener("click", (event) => {
      this.autocompleteSuggestionsContainer.classList.add("hide");
    });

    // Add event listeners to all the fields and update the model
    for (let key in this.fields) {
      this.fields[key].addEventListener("change", (event) => {
        event.target.classList.remove("is-invalid");
        model.delivery[key] = event.target.value;
      });
    }

    for (let key in this.fields) {
      if (key !== 'email' && key !== 'first_name') {
        this.fields[key].addEventListener("change", debounce((event) => {
          model.shippingRate = ""; // reset shipping rate
          controller.deliveryChangeHandler(event);
        }, 1000));
      }
    }

    for (let key in this.fields) { 
      // add an event listener remove class is-invalid if keydown on input 
      this.fields[key].addEventListener("keydown", (event) => {
        event.target.classList.remove("is-invalid");
      });
    }

    // if email input changes then update the checkout email
    this.fields.email.addEventListener("change", (event) => {
      model.delivery.email = event.target.value;
      controller.updateCheckoutEmail();
    });


    this.fields.address1.addEventListener("keydown", debounce((event) => {
      console.log(event);
      let address = event.target.value;
      controller.fetchAddressSuggestions(address, 'delivery');
    }, 1000));

    setTimeout(() => {
      // this.fillInputs();
    },2000);
  },

  removeInvalidClassFields() {
    for (let key in this.fields) {
      this.fields[key].classList.remove("is-invalid");
    }
  },

  renderAutocompleteSuggestions(predictions) {
    console.log("renderAutocompleteSuggestions");
    // lets create li elements for each prediction adding the place_id as data attribute so we can use it later to get the details of the place and fill the inputs
    let suggestions = "";
    predictions.map((prediction) => {
      let newSuggestion = `<li class="combo-box__option" data-place-id="${prediction.place_id}">
        <div class="combo-box__content">
          <span>${prediction.description}</span>
        </div>
      </li>`;
      suggestions += newSuggestion;
    });

    // lets add the suggestions to the ul element
    this.autocompleteSuggestions.innerHTML = suggestions;
    // remove hide class from autocomplete suggestions
    this.autocompleteSuggestionsContainer.classList.remove("hide");

    // add event listener to all the suggestions
    let autocompleteSuggestions = document.querySelectorAll(".combo-box__option");
    autocompleteSuggestions.forEach((suggestion) => {
      suggestion.addEventListener("click", (event) => {

        // if event tarrget is not the li element then look for it and get the place_id
        if (event.target.tagName != "LI") {
          let li = event.target.closest("li");
          let placeId = li.getAttribute("data-place-id");
          controller.fetchDetailAddress(placeId, "delivery");
          return;
        }
        let placeId = event.target.getAttribute("data-place-id");
        controller.fetchDetailAddress(placeId, "delivery");
      });
    });

  },

  fillSuggestionInputs(suggestion) { 
    // lets use the address components from the suggestion to fill the inputs
    let addressComponents = suggestion.address_components;
    let address1 = "";
    let city = "";
    let province = "";
    let zip = "";
    addressComponents.map((component) => {
      if (component.types.includes("street_number")) {
        address1 += component.long_name;
      }

      if (component.types.includes("route")) {
        address1 += " " + component.long_name;
      }

      if (component.types.includes("locality")) {
        city = component.long_name;
      }

      if (component.types.includes("administrative_area_level_1")) {
        province = component.long_name;
      }

      if (component.types.includes("postal_code")) {
        zip = component.long_name;
      }
    });

    this.fields.address1.value = address1;
    this.fields.city.value = city;
    this.fields.province.value = province;
    this.fields.zip.value = zip;

    // trigger change event
    this.fields.address1.dispatchEvent(new Event("change"));
    this.fields.city.dispatchEvent(new Event("change"));
    this.fields.province.dispatchEvent(new Event("change"));
    this.fields.zip.dispatchEvent(new Event("change"));

    this.autocompleteSuggestionsContainer.classList.add("hide");

  },

  changeStateOptions(countryCode) { 
    console.log("changeStateOptions", countryCode);
    // check if country code exists in country_states
    model.delivery.province = "";
    if (!country_states[countryCode]) {
      // if not then hide the state input
      console.log("counrty code no found in country sates");
      this.fields.province.parentElement.classList.add("hide");
      controller.deliveryChangeHandler();
      return;
    }

    // if yes then show the state input
    this.fields.province.parentElement.classList.remove("hide");
    this.fields.province.innerHTML = "";
    let states = country_states[countryCode].states;
    let stateOptions = "";
    // add as he first option the value province that can not be selected
    stateOptions += `<option value="" selected disabled hidden>Select State</option>`;
    states.map((state) => {
      let newState = `<option value="${state}">${state}</option>`;
      stateOptions += newState;
    });
    this.fields.province.innerHTML = stateOptions;
    controller.deliveryChangeHandler();
  },

  fillInputs() {
    // fill the inputs with placeholder data
    this.fields.email.value = "jamosquera@gmail.com";
    
    this.fields.first_name.value = "John";

    this.fields.last_name.value = "Doe";
    this.fields.address1.value = "2841 Bryant Avenue South";
    this.fields.address2.value = "";
    this.fields.city.value = "Minneapolis";
    this.fields.province.value = "Minnesota";
    this.fields.zip.value = "55408";
    this.fields.phone.value = "612-555-1234";

    // trigger change event
    this.fields.email.dispatchEvent(new Event("change"));
    this.fields.first_name.dispatchEvent(new Event("change"));
    this.fields.last_name.dispatchEvent(new Event("change"));
    this.fields.address1.dispatchEvent(new Event("change"));
    this.fields.address2.dispatchEvent(new Event("change"));
    this.fields.city.dispatchEvent(new Event("change"));
    this.fields.province.dispatchEvent(new Event("change"));
    this.fields.zip.dispatchEvent(new Event("change"));
    this.fields.phone.dispatchEvent(new Event("change"));

  }
}

const cartItemsView = {
  init() { 
    this.cartItemsContainer = document.querySelectorAll(".cart__items");
  },

  updateLineItems() { 
    console.log("updateLineItems");
    model.cart_items.items.map((item) => {
      this.updateItem(item.variant_id, item.discountedAmount, item.totalAmount, item.subtotalAmount);
    });
  },

  updateItem(variantId, discountedAmount, totalAmount, subtotalAmount) { 
    // Loop through each container in the NodeList
    this.cartItemsContainer.forEach(container => {
      let cartItem = container.querySelector(`[data-variantid="${variantId}"]`);
      
      if (cartItem) {
        let discountedAmountElement = cartItem.querySelector(".cart__item-discounted-amount");
        let totalAmountElement = cartItem.querySelector(".cart__price").querySelector("span");
        let subtotalAmountElementContainer = cartItem.querySelector(".cart__item-subtotal-amount");
        let subtotalAmountElement = subtotalAmountElementContainer.querySelector("span");
        
        // Update the price display
        totalAmountElement.textContent = `$${formatPrice(totalAmount)}`;

        // Update the discounted amount display
        if (discountedAmount > 0) {
          subtotalAmountElementContainer.classList.remove("hide");
          subtotalAmountElement.textContent = `$${subtotalAmount}`;
        } else {
          subtotalAmountElementContainer.classList.add("hide");
        }
      }
    });
  }
}

const billingView = { 
  init() {
    this.billingAddressCheckbox = document.querySelector("#billing-address-checkbox");
    this.billingAddressContainer = document.querySelector("#billing-address-container");

    this.fields = {
      country: document.querySelector("#BillingFormCountry"),
      first_name: document.querySelector("#BillingFormFirstName"),
      last_name: document.querySelector("#BillingFormLastName"),
      address1: document.querySelector("#BillingFormAddress1"),
      address2: document.querySelector("#BillingFormAddress2"),
      city: document.querySelector("#BillingFormCity"),
      province: document.querySelector("#BillingFormState"),
      zip: document.querySelector("#BillingFormZipCode"),
    };

    this.autocompleteSuggestionsContainer = document.querySelector("#autocomplete-suggestions-container-billing");
    this.autocompleteSuggestions = document.querySelector("#autocomplete-suggestions-billing");
    this.suggestionsCloseBtn = document.querySelector("#suggestions-close-btn-billing");

    // Add event listeners to all the fields and update the model
    for (let key in this.fields) {
      this.fields[key].addEventListener("change", (event) => {
        model.billing[key] = event.target.value;
      });
    }

    this.fields.country.addEventListener("change", (event) => {
      let selectionOption = event.target.selectedOptions[0];
      model.billing.country = selectionOption.getAttribute("data-code");
      console.log("model.billing.country", model.billing.country);
      this.changeStateOptions(model.billing.country);
    });

    this.fields.address1.addEventListener("keydown", debounce((event) => {
      console.log(event);
      let address = event.target.value;
      controller.fetchAddressSuggestions(address, 'billing');
    }, 1000));

    // add event listener to the checkbox
    this.billingAddressCheckbox.addEventListener("change", (event) => {
      if (event.target.checked) {
        this.billingAddressContainer.classList.add("hide");
        model.billing.same_as_delivery = true;
      } else {
        this.billingAddressContainer.classList.remove("hide");
        model.billing.same_as_delivery = false;
      }
    });
  },

  changeStateOptions(countryCode) { 
    console.log("changeStateOptions", countryCode);
    // check if country code exists in country_states
    model.billing.province = "";
    if (!country_states[countryCode]) {
      // if not then hide the state input
      console.log("counrty code no found in country sates");
      this.fields.province.parentElement.classList.add("hide");
      return;
    }

    // if yes then show the state input
    this.fields.province.parentElement.classList.remove("hide");
    this.fields.province.innerHTML = "";
    let states = country_states[countryCode].states;
    let stateOptions = "";
    // add as he first option the value province that can not be selected
    stateOptions += `<option value="" selected disabled hidden>Select State</option>`;
    states.map((state) => {
      let newState = `<option value="${state}">${state}</option>`;
      stateOptions += newState;
    });
    this.fields.province.innerHTML = stateOptions;
  },

  renderAutocompleteSuggestions(predictions) { 
    console.log("renderAutocompleteSuggestions");
    // lets create li elements for each prediction adding the place_id as data attribute so we can use it later to get the details of the place and fill the inputs
    let suggestions = "";
    predictions.map((prediction) => {
      let newSuggestion = `<li class="combo-box__option" data-place-id="${prediction.place_id}">
        <div class="combo-box__content">
          <span>${prediction.description}</span>
        </div>
      </li>`;
      suggestions += newSuggestion;
    });

    // lets add the suggestions to the ul element
    this.autocompleteSuggestions.innerHTML = suggestions;
    // remove hide class from autocomplete suggestions
    this.autocompleteSuggestionsContainer.classList.remove("hide");

    // add event listener to all the suggestions
    let autocompleteSuggestions = document.querySelectorAll(".combo-box__option");
    autocompleteSuggestions.forEach((suggestion) => {
      suggestion.addEventListener("click", (event) => {

        // if event tarrget is not the li element then look for it and get the place_id
        if (event.target.tagName != "LI") {
          let li = event.target.closest("li");
          let placeId = li.getAttribute("data-place-id");
          controller.fetchDetailAddress(placeId, "billing");
          return;
        }
        let placeId = event.target.getAttribute("data-place-id");
        controller.fetchDetailAddress(placeId, "billing");
      });
    });
  
  },

  fillSuggestionInputs(suggestion) {
    // lets use the address components from the suggestion to fill the inputs
    let addressComponents = suggestion.address_components;
    let address1 = "";
    let city = "";
    let province = "";
    let zip = "";
    addressComponents.map((component) => {
      if (component.types.includes("street_number")) {
        address1 += component.long_name;
      }

      if (component.types.includes("route")) {
        address1 += " " + component.long_name;
      }

      if (component.types.includes("locality")) {
        city = component.long_name;
      }

      if (component.types.includes("administrative_area_level_1")) {
        province = component.long_name;
      }

      if (component.types.includes("postal_code")) {
        zip = component.long_name;
      }
    });

    this.fields.address1.value = address1;
    this.fields.city.value = city;
    this.fields.province.value = province;
    this.fields.zip.value = zip;

    // trigger change event
    this.fields.address1.dispatchEvent(new Event("change"));
    this.fields.city.dispatchEvent(new Event("change"));
    this.fields.province.dispatchEvent(new Event("change"));
    this.fields.zip.dispatchEvent(new Event("change"));

    this.autocompleteSuggestionsContainer.classList.add("hide");

  }

}

const shippingView = { 
  init() { 
    this.shippingOptions = document.querySelector("#shipping-options");
    this.shippingOptionsError = document.querySelector("#shipping-options-error");
  },

  hideShippingOptions() { 
    this.shippingOptionsError.classList.remove("hide");
    this.shippingOptions.classList.add("hide");
  },

  updateShippingOptions(rates) { 
    console.log("updateShippingOptions", rates);
    let availableRates = "";
    if (!rates) return;
    rates.map((rate, idx) => {
      let newRate = `
      <div class="form-check mt-1">
        <input class="form-check-input shipping-option" value="${rate.handle}" type="radio" name="flexRadioDefault" id="rate-${idx}" data-draft-handle="${rate?.draftOrderHandle} data-price="${rate.estimatedCost.amount}" ${rates.length == 1 ? 'checked' : ''} data-title="${rate.title}">
        <label class="form-check-label" for="rate-${idx}">
          <div class="shipping-option-label">
          <span class="shipping-option-label-title">${rate.title}</span><span>${rate.estimatedCost.amount == 0 ? 'Free' : '$' + formatPrice(parseFloat(rate.estimatedCost.amount))}</span>
          </div>
        </label>
      </div>
      `
      availableRates += newRate;
    });

    this.shippingOptions.innerHTML = availableRates;

    // when there is only one rate available select it, update model and update total Cost  View
    if (rates.length == 1) {
      this.shippingOptions.querySelector(".shipping-option").checked = true;
      model.shippingRate = {
        "price": rates[0].estimatedCost.amount*100,
        "title": rates[0].title,
        "handle": rates[0].handle,
        "draftOrderHandle": rates[0].draftOrderHandle
      }

      controller.shippingChangeHandler();
    } else {
      // add event listener to all the shipping options
      let shippingOptions = document.querySelectorAll(".shipping-option");
      shippingOptions.forEach((option) => {
        option.addEventListener("change", (event) => {
          let price = event.target.getAttribute("data-price");
          model.shippingRate = {
            "price": price*100,
            "title": event.target.getAttribute("data-title"),
            "handle": event.target.value,
            "draftOrderHandle": event.target.getAttribute("data-draft-handle")
          }
          controller.shippingChangeHandler();
        });
      });
    }
  }
}

const totalCostView = { 
  init() { 
    this.shippingCost = document.querySelector("#shipping-cost");
    this.shippingCostSmall = document.querySelector("#shipping-cost-small");
    this.totalCost = document.querySelector("#total-cost");
    this.totalCostSmall = document.querySelector("#total-cost-small");
    this.subtotalCost = document.querySelector("#subtotal-cost");
    this.subtotalCostSmall = document.querySelector("#subtotal-cost-small");
    this.totalCostSummary = document.querySelector("#total-cost-summary");
    this.totalCostSummaryBefore = document.querySelector("#total-cost-summary-before");
    this.submitButton = document.querySelector("#multi-card-field-button");
    this.resultMessageContainer = document.querySelector("#result-message-container");
    this.submitButton.setAttribute("disabled", "");
    this.discountContainer = document.querySelector(".cart__item--discount");
    this.discountCodeView = document.querySelector("#discount-code-view");
    this.discountAmount = document.querySelector("#discount-amount");
    this.paymentMethods = document.querySelectorAll(".payment-method");
    this.creditCardForm = document.querySelector("#card-form");
    this.AffirmSubmitBtn = document.querySelector("#affirm-submit-btn");
    this.affirmContainer = document.querySelector("#affirm-container");
    this.AffirmSubmitBtn.setAttribute("disabled", "");
    this.paymentMethosContainer = document.querySelector("#payment-methods-container");
    this.freePaymentContainer = document.querySelector("#free-payment-container");
    this.freeSubmitButton = document.querySelector("#free-submit-button");


    // add event listener to payment methods
    this.paymentMethods.forEach((method) => {
      method.addEventListener("click", (event) => {
        let paymentMethod = event.target.value;
        model.paymentMethod = paymentMethod;
        console.log("paymentMethod", paymentMethod);
        if (paymentMethod == "credit-card") {
          this.creditCardForm.classList.remove("hide");
          this.AffirmSubmitBtn.classList.add("hide");
          this.affirmContainer.classList.add("hide");
          this.submitButton.classList.remove("hide");
          return;
        }

        if (paymentMethod == "affirm") {
          this.creditCardForm.classList.add("hide");
          this.AffirmSubmitBtn.classList.remove("hide");
          this.affirmContainer.classList.remove("hide");
          this.submitButton.classList.add("hide");
          return;
        }
      });
    });

    // add event listener to affirm submit button
    this.AffirmSubmitBtn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      controller.createAffirmCheckout();
    });

    this.freeSubmitButton.addEventListener("click", (event) => { 
      event.preventDefault();
      event.stopPropagation();
      controller.completeFreeCheckoutHandler();
    });
  },

  updateView(discountCode="") {
    this.resultMessageContainer.classList.add("hide");

    if (model.shippingRate == "") {
      this.shippingCost.innerHTML = "Enter Shipping Address";
      this.shippingCostSmall.innerHTML = "Enter Shipping Address";
      this.submitButton.setAttribute("disabled", "");
      this.AffirmSubmitBtn.setAttribute("disabled", "");

    } else {
      let shippingCost = model.shippingRate.price;
      this.shippingCost.innerHTML = `${shippingCost == 0 ? 'Free' : '$' + formatPrice(shippingCost/100)}`;
      this.shippingCostSmall.innerHTML = `${shippingCost == 0 ? 'Free' : '$' + formatPrice(shippingCost/100)}`;
      this.submitButton.removeAttribute("disabled");
      this.AffirmSubmitBtn.removeAttribute("disabled");
    }

    if(discountCode != "") { 
      this.discountContainer.classList.remove("hide");
      this.discountCodeView.innerHTML = discountCode;
      if (model.discountAmount != 0) {
        this.discountAmount.innerHTML = `-$${formatPrice(model.discountAmount/100)}`;
        this.totalCostSummaryBefore.innerHTML = `<s>$${formatPrice((parseFloat(model.totalAmount) + parseFloat(model.discountAmount))/100)}</s>`;
        this.totalCostSummaryBefore.classList.remove("hide");
      }
    } else {
      this.discountContainer.classList.add("hide");
      this.totalCostSummaryBefore.classList.add("hide");
      
    }

    let totalAmount = model.totalAmount
    let totalCost = parseFloat(totalAmount);
    this.totalCost.innerHTML = `$${formatPrice(totalCost/100)}`; 
    this.totalCostSmall.innerHTML = `$${formatPrice(totalCost/100)}`;
    this.totalCostSummary.innerHTML = `$${formatPrice(totalCost/100)}`;

    let subtotalAmount = model.subtotal;
    let subtotalCost = parseFloat(subtotalAmount);
    this.subtotalCost.innerHTML = `$${formatPrice(subtotalCost/100)}`;
    this.subtotalCostSmall.innerHTML = `$${formatPrice(subtotalCost/100)}`;
  },

  renderFreePayment() { 
    this.paymentMethosContainer.classList.add("hide");
    this.freePaymentContainer.classList.remove("hide");
    this.submitButton.classList.add("hide");
    this.AffirmSubmitBtn.classList.add("hide");
    this.freeSubmitButton.classList.remove("hide");
  },

  hideFreePayment() {
    this.paymentMethosContainer.classList.remove("hide");
    this.freePaymentContainer.classList.add("hide");
    this.freeSubmitButton.classList.add("hide");
    if (model.paymentMethod == "credit-card") {
      this.submitButton.classList.remove("hide");
      this.AffirmSubmitBtn.classList.add("hide");
    } else {
      this.submitButton.classList.add("hide");
      this.AffirmSubmitBtn.classList.remove("hide");
    }
  }
}

const discountCodeView = {
  init() { 
    this.discountCodeInput = document.querySelector("#discount-code-input");
    this.discountCodeButton = document.querySelector("#discount-code-button");
    this.discountCodeError = document.querySelector("#discount-code-error");
    this.discountCodeWarning = document.querySelector("#discount-code-warning");
    this.discountCodeWarningText = document.querySelector("#discount-code-warning-text");
    this.discountCodeWarningClose = document.querySelector("#discount-code-warning-close");
    this.discountCodeApplied = document.querySelector("#discount-code-applied");
    this.discountCodeAppliedText = document.querySelector("#discount-code-applied-text");
    this.discountCodeAppliedClose = document.querySelector("#discount-code-applied-close");

    this.discountCodeInput.addEventListener("keydown", (event) => { 
      this.hideDiscountCodeError();
      setTimeout(() => {
        if (event.target.value == "") {
          this.discountCodeButton.setAttribute("disabled", "");
        } else {
          this.discountCodeButton.removeAttribute("disabled");
        }
      },100);
    });
      
    // add event listener to button
    this.discountCodeButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      // get the discount value and call controller method to apply discount
      let discountCode = this.discountCodeInput.value;
      try{
        controller.applyDiscount(discountCode);
      } catch(error) {
        console.log("error", error);
        Sentry.captureMessage('Apply Discount Error', { extra: { "error": error } });
        Sentry.captureException(error);
        discountCodeView.showDiscountCodeError("ERROR");
      }
    });

    // add event listener to close button
    this.discountCodeWarningClose.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.discountCodeWarning.classList.add("hide");
    });

    // add event listener to close button
    this.discountCodeAppliedClose.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      try {
        controller.removeDiscountHandler();
        this.discountCodeApplied.classList.add("hide");
        this.discountCodeInput.value = "";
      } catch(error) {
        console.log("error", error);
        Sentry.captureMessage('Remove Discount Error', { extra: { "error": error } });
        Sentry.captureException(error);
      }
    });

    // if size is mobile then move discount container to another div
    if (window.innerWidth < 768) {
      let discountContainer = document.querySelector(".discount_code_container");
      let target = document.querySelector('.discount-container-small');
      target.appendChild(discountContainer);

      let discountSmall = document.querySelector('.cart__item--discount')
      let targetSmall = document.querySelector('.cart__item--discount-small');
      targetSmall.appendChild(discountSmall);
    }
  },

  showDiscountCodeError(message, discountCode="") {
    this.removeDiscountCode(); 
    if (message == "DISCOUNT_NOT_FOUND") {
      this.discountCodeError.innerHTML = "Enter a valid discount code or gift card";
      this.discountCodeError.classList.remove("hide");
      this.discountCodeInput.classList.add("is-invalid");
      return;
    }

    if (message == "DISCOUNT_EXPIRED") {
      this.discountCodeError.innerHTML = "This discount is not valid anymore";
      this.discountCodeError.classList.remove("hide");
      this.discountCodeInput.classList.add("is-invalid");
      return;
    }

    if (message == "ERROR") { 
      this.discountCodeError.innerHTML = "Something went wrong. Please try again";
      this.discountCodeError.classList.remove("hide");
      return;
    }

    if (message == "DISCOUNT_NOT_APPLICABLE") {
      this.discountCodeWarning.classList.remove("hide");
      this.discountCodeWarningText.innerHTML = `<b>${discountCode}</b> discount code isn’t valid for the items in your cart`;
      return;
    }
  },

  hideDiscountCodeError() { 
    this.discountCodeError.classList.add("hide");
    this.discountCodeInput.classList.remove("is-invalid");
    this.discountCodeWarning.classList.add("hide");
  },

  renderDiscountCode(discountCode) { 
    if (discountCode != "") {
      this.discountCodeApplied.classList.remove("hide");
      this.discountCodeAppliedText.innerHTML = `<b>${discountCode}</b>`;
    } else {
      this.discountCodeApplied.classList.add("hide");
    }
  },

  removeDiscountCode() { 
    this.discountCodeApplied.classList.add("hide");
  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatPrice(x) {
  return numberWithCommas(Number(x).toFixed(2));
}

controller.init();

function completeDraftOrder() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${SERVER_URL}/complete_draft_order/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          draft_order_id: model.draftOrderId,
          store: model.store,
        }),
      });

      const data = await response.json();
      console.log("orderData", data);

      if (data.url) {
        resolve(data);
      } else {
        const errorDetail = data?.details?.[0];
        const errorMessage = errorDetail
          ? `${errorDetail.issue} ${errorDetail.description} (${data.debug_id})`
          : JSON.stringify(data);

        reject(new Error(errorMessage));
      }
    } catch (error) {
      console.error(error);
      reject(new Error(`Could not initiate PayPal Checkout...<br><br>${error}`));
    }
  });
}

async function createOrderCallback() {
  Sentry.captureMessage('Create Order Callback', { extra: { "data": JSON.stringify({
    cart_items: model.cart_items,
    delivery: model.delivery,
    billing: model.billing,
    shippingRate: model.shippingRate,
    discountAmount: model.discountAmount,
    discountCode: model.discountCode,
    
  }) } });
  try {
    const response = await fetch(`${SERVER_URL}/create_order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // use the "body" param to optionally pass additional order information
      // like product ids and quantities
      body: JSON.stringify({
        cart_items: model.cart_items,
        delivery: model.delivery,
        billing: model.billing,
        shippingRate: model.shippingRate,
        discountAmount: model.discountAmount,
        discountCode: model.discountCode,
        requiresShipping: model.requiresShipping,
        isCustomItems: model.isCustomItems,
        attributes: model.attributes,
        store: model.store,
      }),
    });

    const data = await response.json();
    console.log("orderData", JSON.stringify(data));

    if (data.status == "error") { 
      throw new Error(data.message);
    }

    const orderData = data.order;
    const dratfOrder = data.draftOrder;
    model.draftOrderId = dratfOrder;

    if (orderData.id) {
      return orderData.id;
    } else {
      const errorDetail = orderData?.details?.[0];
      const errorMessage = errorDetail
        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
        : JSON.stringify(orderData);

      throw new Error(errorMessage);
    }
  } catch (error) {
    console.log('Could not initiate PayPal Checkout');
    console.error(error);
    resultMessage(`Sorry, your transaction could not be processed<br>${error}`);
    Sentry.captureException(error);
  }
}

async function onApproveCallback(data, actions) {
  try {
    const response = await fetch(`${SERVER_URL}/complete_order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        order_id: data.orderID,
      }),
    });

    const orderData = await response.json();
    // Three cases to handle:
    //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
    //   (2) Other non-recoverable errors -> Show a failure message
    //   (3) Successful transaction -> Show confirmation or thank you message

    const transaction =
      orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
      orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
    const errorDetail = orderData?.details?.[0];

    // this actions.restart() behavior only applies to the Buttons component
    if (errorDetail?.issue === "INSTRUMENT_DECLINED" && !data.card && actions) {
      // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
      // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
      console.log("INSTRUMENT_DECLINED", JSON.stringify(errorDetail));
      return actions.restart();
    } else if (
      errorDetail ||
      !transaction ||
      transaction.status === "DECLINED"
    ) {
      // (2) Other non-recoverable errors -> Show a failure message
      let errorMessage;
      if (transaction) {
        errorMessage = `Transaction ${transaction.status}: ${transaction.id}`;
      } else if (errorDetail) {
        errorMessage = `${errorDetail.description} (${orderData.debug_id})`;
      } else {
        errorMessage = JSON.stringify(orderData);
      }
      Sentry.captureMessage('Transaction Declined', { extra: { "error": errorMessage } });
      throw new Error(errorMessage);
    } else {
      // (3) Successful transaction -> Show confirmation or thank you message
      // Or go to another URL:  actions.redirect('thank_you.html');
      console.log(
        "Capture result",
        orderData,
        JSON.stringify(orderData, null, 2),
      );

      resultMessage(
        `Transaction ${transaction.status}: ${transaction.id}`,
      );
      document.getElementById("multi-card-field-button").classList.remove("btn--loading");

      const shopifyOrder = await completeDraftOrder();
      console.log("order-url", shopifyOrder);
      // send conversion to google ads
      // window.gtag('event', 'conversion', {
      //   'send_to': 'AW-942461643/kqjaCJCSnF4Qy6WzwQM',
      //   'transaction_id': shopifyOrder.order_id,
      //   'value': shopifyOrder.order_value,
      //   'currency': 'USD',
      // });

      // redirect to shopify order url
      Sentry.captureMessage('Purchase Complete', { extra: { "checkoutId": model.checkoutId } });
      window.location.href = shopifyOrder.url;
      // actions.redirect(shopifyOrder.url);

    }
  } catch (error) {
    Sentry.captureException(error);
    console.error(error);
    document.getElementById("multi-card-field-button").classList.remove("btn--loading");
    resultMessage(
      `Sorry, your transaction could not be processed.<br>`,
    );
    controller.deleteDraftOrder();
  }
}

// window.paypal
//   .Buttons({
//     createOrder: createOrderCallback,
//     onApprove: onApproveCallback,
//   })
//   .render("#paypal-button-container");

const cardStyle = {
  'input': {
      'font-size': '15px',
      'font-family': 'system-ui, BlinkMacSystemFont, Helvetica Neue',
      'font-weight': '400',
      'color': '#000000',
      'padding': '10px'
  },
  '.invalid': {
      'color': 'red',
  },
};

const cardField = window.paypal.CardFields({
  createOrder: createOrderCallback,
  onApprove: onApproveCallback,
  style: cardStyle,
});

console.log("CardFields eligible?", cardField.isEligible());

// Render each field after checking for eligibility
if (cardField.isEligible()) {
  const nameField = cardField.NameField({
    placeholder: "Name on card"
  });
  nameField.render("#card-name-field-container");

  const numberField = cardField.NumberField();
  numberField.render("#card-number-field-container");

  const cvvField = cardField.CVVField({
    placeholder: "Security code"
  });
  cvvField.render("#card-cvv-field-container");

  const expiryField = cardField.ExpiryField({
    placeholder: "Expiration date (MM/YY)"
  });
  expiryField.render("#card-expiry-field-container");

  const paypalSubmitButton = document.getElementById("multi-card-field-button");

  // Add click listener to submit button and call the submit function on the CardField component
  document.getElementById("multi-card-field-button")
    .addEventListener("click", async () => {
      // lets validate the form before submitting, we need to make sure all the fields are valid
      let isFormValid = await controller.validateForm();
      if (!isFormValid) {
        resultMessage("Please fill out all fields correctly");
        return;
      }

      cardField.getState()
        .then((state) => {
          if (!state.isFormValid) {
            resultMessage("Please fill out all fields correctly");
            return;
          }
          // add class btn--loading to button
          paypalSubmitButton.classList.add("btn--loading");
          cardField.submit().catch((error) => {
            console.log("transaction could not be processed");
            Sentry.captureException(error);
            paypalSubmitButton.classList.remove("btn--loading");
          resultMessage(
            `Sorry, your transaction could not be processed.<br>${error}`,
          );
          controller.deleteDraftOrder();
        });
      });
    });
} else {
  // Hides card fields if the merchant isn't eligible
  document.querySelector("#card-form").style = "display: none";
  Sentry.captureMessage('CardFields not eligible', { extra: { "message": "CardFields not eligible" } });
  // paypal.Buttons().render("#paypal-buttons-container");
}

// Example function to show a result to the user. Your site's UI library can be used instead.
function resultMessage(message) {
  const container = document.querySelector("#result-message-container");
  const text = document.querySelector("#result-message-text");
  container.classList.remove("hide");
  text.innerHTML = message;
}

function clearResultMessage() {
  const container = document.querySelector("#result-message-container");
  const text = document.querySelector("#result-message-text");
  container.classList.add("hide");
  text.innerHTML = "";
}

function sanitizeValue(value) {
  return value ? parseInt(parseFloat(value) * 100) : 0;
}

async function fetchWithRetry(url, options, retryCount = 3) {
  for (let i = 0; i < retryCount; i++) {
    try {
      let response = await fetch(url, options);
      let data = await response.json();
      return data;
    } catch (error) {
      if (i === retryCount - 1) throw error;
      console.log(`Fetch attempt ${i + 1} failed, retrying...`);
      Sentry.addBreadcrumb({category: 'fetchWithRetry', message: `Fetch attempt ${i + 1} failed, retrying...`, level: 'info'});
    }
  }
}

